import {useState, useRef} from "react";
import {useToast} from "@chakra-ui/react";
import useMerchantPortalAxios from "../utils/axios";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import useLogout from "./logoutApi";

const OverviewAPI = () => {
        const toast = useToast();
        const toastRef = useRef(null);
        const MerchantPortalAxios = useMerchantPortalAxios();
        const [CurBalDOL, setCurBalDOL] = useState([]);
        const [CurBalLBP, setCurBalLBP] = useState([]);
        const [StatBalDOL, setStatBalDOL] = useState([]);
        const [transactionsToApprove, setTransactionsToApprove] = useState([]);
        const [StatBalLBP, setStatBalLBP] = useState([]);
        const [accountLoading, setAccountLoading] = useState(true);
        const [chartLoading, setChartLoading] = useState(true);
        const [approveListLoading, setApproveListLoading] = useState(true);

        const [initiateTransfer, setInitiateTransfer] = useState(null);


        async function GetAccountBalance(dateFrom, dateTo) {
                setAccountLoading(true);
                if (sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE")
                    return;
                const res = await MerchantPortalAxios.post(
                    `/v1/Overview/GetAccountBalance`,
                    {
                        SessionID: sessionStorage.getItem("SessionID"),
                        DateFrom: dateFrom,
                        DateTo: dateTo,
                    }
                );

                if (res.data.Payload.CurrenciesOverview[0] && res.data.Payload.CurrenciesOverview[0].CurrencyBalances) {
                    if (res.data.Payload.CurrenciesOverview[0].CurrencyBalances.Book !== null) {
                        sessionStorage.setItem("usdAmount", res.data.Payload.CurrenciesOverview[0].CurrencyBalances.Available.toLocaleString('en-US'));
                    } else {
                        sessionStorage.setItem("usdAmount", "0");
                    }

                    setCurBalDOL(res.data.Payload.CurrenciesOverview[0].CurrencyBalances);
                    setAccountLoading(false);
                }

                if (res.data.Payload.CurrenciesOverview[1] && res.data.Payload.CurrenciesOverview[1].CurrencyBalances) {
                    if (res.data.Payload.CurrenciesOverview[1].CurrencyBalances.Book !== null) {
                        sessionStorage.setItem("lbpAmount", res.data.Payload.CurrenciesOverview[1].CurrencyBalances.Available.toLocaleString('en-US'));
                    } else {
                        sessionStorage.setItem("lbpAmount", "0");
                    }
                    setCurBalLBP(res.data.Payload.CurrenciesOverview[1].CurrencyBalances);
                }
        }


        async function GetSOAChartsData(dateFrom, dateTo) {
            setChartLoading(true);
            await MerchantPortalAxios.post(
                `/v1/Overview/GetSOAChartsData`,
                {
                    SessionID: sessionStorage.getItem("SessionID"),
                    DateFrom: dateFrom,
                    DateTo: dateTo,
                }
            ).then((res) => {
                setStatBalDOL(res.data.Payload.LegalSOACharts[0].ChartsPoints);
                setStatBalLBP(res.data.Payload.LegalSOACharts[1].ChartsPoints);
                setChartLoading(false);
            })
        }

        async function GetTransactionsToApprove() {
            const req = new BaseRequest(
                sessionStorage.getItem("SessionID")
            );
            await MerchantPortalAxios.post(
                `/v1/Overview/GetTransactionsToApprove`,
                req
            ).then((res) => {
                setTransactionsToApprove(res.data.Payload.TransactionsAwaitingApproval);
                setApproveListLoading(false);
            })
        }

        async function ApproveRejectAwaitingTrx(payload) {
            const res = await MerchantPortalAxios.post(
                `/v1/Overview/ApproveRejectAwaitingTrx`,
                payload);

            return res.data.Payload;
        }


        async function ApproveListAwaitingTrx(payload) {
            const res = await MerchantPortalAxios.post(
                `/v1/Overview/ApproveListAwaitingTrx`,
                payload
            );

            return res.data.Payload;
        }

        async function InitiateTransferToLegal() {
            const req = new BaseRequest(
                sessionStorage.getItem("SessionID")
            );
            await MerchantPortalAxios.post(
                `/v1/EODClosing/InitiateTransferToLegal`,
                req
            ).then((res) => {
                setInitiateTransfer(res.data.Payload);
            }).catch((err) => {
                toastRef.current = toast({
                    position: "top",
                    description: err.response?.data.PopupDescription,
                    status: "error",
                    duration: "5000",
                    isClosable: "false",
                });
            });
        }

        const ConfirmTransferToLegal = async (payload) => {
            const res = await MerchantPortalAxios.post(
                `/v1/EODClosing/ConfirmTransferToLegal`,
                payload
            )
            return res.data;
        }

        return {
            GetAccountBalance,
            GetSOAChartsData,
            GetTransactionsToApprove,
            ApproveRejectAwaitingTrx,
            ApproveListAwaitingTrx,
            InitiateTransferToLegal,
            ConfirmTransferToLegal,
            CurBalDOL,
            CurBalLBP,
            StatBalDOL,
            StatBalLBP,
            accountLoading,
            chartLoading,
            transactionsToApprove,
            approveListLoading,
            initiateTransfer,
            setInitiateTransfer
        };
    }
;

export default OverviewAPI;
